// extracted by mini-css-extract-plugin
export var grid = "_y-0";
export var span1 = "_y-2";
export var span10 = "_y-b";
export var span10L = "_y-z";
export var span10M = "_y-n";
export var span10Xl = "_y-1b";
export var span11 = "_y-c";
export var span11L = "_y-10";
export var span11M = "_y-o";
export var span11Xl = "_y-1c";
export var span12 = "_y-d";
export var span12L = "_y-11";
export var span12M = "_y-p";
export var span12Xl = "_y-1d";
export var span1L = "_y-q";
export var span1M = "_y-e";
export var span1Xl = "_y-12";
export var span2 = "_y-3";
export var span2L = "_y-r";
export var span2M = "_y-f";
export var span2Xl = "_y-13";
export var span3 = "_y-4";
export var span3L = "_y-s";
export var span3M = "_y-g";
export var span3Xl = "_y-14";
export var span4 = "_y-5";
export var span4L = "_y-t";
export var span4M = "_y-h";
export var span4Xl = "_y-15";
export var span5 = "_y-6";
export var span5L = "_y-u";
export var span5M = "_y-i";
export var span5Xl = "_y-16";
export var span6 = "_y-7";
export var span6L = "_y-v";
export var span6M = "_y-j";
export var span6Xl = "_y-17";
export var span7 = "_y-8";
export var span7L = "_y-w";
export var span7M = "_y-k";
export var span7Xl = "_y-18";
export var span8 = "_y-9";
export var span8L = "_y-x";
export var span8M = "_y-l";
export var span8Xl = "_y-19";
export var span9 = "_y-a";
export var span9L = "_y-y";
export var span9M = "_y-m";
export var span9Xl = "_y-1a";
export var stretch = "_y-1";